import React from "react";
import { Sparkles, ShieldCheck, ClipboardCheck } from "lucide-react";

const FEATURES = [
  {
    icon: Sparkles,
    title: "Governed AI Drafting",
    body: "AI drafts CAPA reports, deviation records, and SOP revisions. Your QA staff reviews and approves every output before it becomes a controlled document.",
  },
  {
    icon: ShieldCheck,
    title: "ALCOA+ Audit Trail",
    body: "Every document carries a timestamped record of who drafted, who reviewed, and when. Built to satisfy 21 CFR Part 11 and CAP electronic records requirements.",
  },
  {
    icon: ClipboardCheck,
    title: "Inspection Readiness",
    body: "Gap reports mapped to specific CLIA and CAP checklist items. Know where your documentation stands before an inspector does.",
  },
];

export default function FeatureCards() {
  return (
    <section className="pb-16 bg-background">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-6">
        {FEATURES.map(({ icon: Icon, title, body }) => (
          <div key={title} className="bg-card border border-border rounded-[10px] p-7 shadow-sm">
            <div className="w-11 h-11 rounded-[10px] bg-accent flex items-center justify-center mb-4">
              <Icon className="w-5 h-5 text-brand-teal" />
            </div>
            <h3 className="text-lg font-bold text-brand-navy mb-2">{title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}